import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  listbox: {
    fontSize: "14px",
  },
  inputRoot: {
    fontSize: "14px",
  },
  mediumSizePopper: {
    minWidth: theme.spacing(40),
  },
  largeSizePopper: {
    minWidth: theme.spacing(60),
  },
  inputRoot: {
    fontSize: 14,
    minHeight: 40,
    padding: "4px 8px"
  },
}));

export default useStyles;
